import { useContext } from 'react'
import { BranchesContext } from './BranchesContext';

export const useBranches = () => useContext(BranchesContext)